define('shared/initializer/form/newHouseAdapters/mixins/StoreOfferIdIntoState',[
    '../../constants',
    'shared/lib/RSVP',
    'shared/remote/offer/get',
    'shared/util/dispatchers/FormDataDispatcher',
    'shared/util/state/adapters/order',
    'shared/util/state',
    'shared/util/checkout/coupon',
    'shared/util/checkout/RedemptionCodeHelper',
    'shared/lib/URI',
    'shared/lib/cookie'
],
function  (
    constants,
    RSVP,
    getOffer,
    FormDataDispatcher,
    orderAdapter,
    state,
    couponUtil,
    RedemptionCode,
    URI,
    cookie
) {
    'use strict';
    function Ctor(){}

    Ctor.prototype.doPageLoad = function(){
        var me = this;

        if (!me.redemptionCode) {
            me.redemptionCode = new RedemptionCode(me.options.useRedemptionCode);
        }

        return RSVP.resolve()
            .then(function(){
                return state.adapters.add(orderAdapter);
            })
            .then(function(){
                var dispatcher = new FormDataDispatcher(me.$form);
                var items = {};
                items[constants.State.OrderOfferId] = {
                    sources:
                    [{
                        retrieve:function(){
                            var uri = new URI(location.href);
                            var query = uri.query(true);
                            return RSVP.resolve(query['offerid']?query['offerid'].split(','):null);
                        },
                        allowUndefined: false
                    },
                    {
                        retrieve:function(){
                            var offerId = cookie.get('et_offerid');
                            return RSVP.resolve(offerId?[offerId + '']:null);
                        }
                    },
                    {
                        type: 'state',
                        doNotWait: true,
                        allowUndefined: false
                    },
                    {
                        retrieve:function(){
                            return RSVP.resolve(me.options.offerIds?me.options.offerIds.split(','):null);
                        },
                        allowUndefined: true
                    }],
                    targets:
                    [{
                        type: 'state'
                    }]
                };

                return dispatcher.dispatch({
                    items: items,
                    timeout: 1000 * 60 * 60
                });
            });

    };

    return Ctor;
});
